import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';

const Step1 = ({ formData, setFormData, setFile }) => {

    return (
        <Fragment>

            <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Leverancier</Form.Label>
                <Form.Select
                    value={formData.supplier}
                    onChange={(e) => setFormData({ ...formData, supplier: e.target.value })}
                    aria-label="Selecteer leverancier"
                >
                    <option>Selecteer</option>
                    <option value="Jellema">Jellema Automatiseringservice</option>
                    <option value="ALSO">ALSO</option>
                </Form.Select>
            </Form.Group>

            <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Bestand</Form.Label>
                <Form.Control
                    onChange={(e) => {
                        setFile(e.target.files[0]);
                        setFormData({ ...formData, file: e.target.files[0]?.name });
                    }}
                    accept=".xls,.xlsx,.csv"
                    type="file"
                />
            </Form.Group>

        </Fragment>
    );
};

export default Step1;
